import css from './background.css'

export default function(isSticker) {
    return `<div class="${isSticker ? css.checkerboard : css.background}" data-background></div>`
}



// WEBPACK FOOTER //
// ./js/embeds/gif/components/background/index.js